import { render, staticRenderFns } from "./C_ShowPage.vue?vue&type=template&id=e999c3a8&scoped=true&"
import script from "./C_ShowPage.vue?vue&type=script&lang=js&"
export * from "./C_ShowPage.vue?vue&type=script&lang=js&"
import style0 from "./C_ShowPage.vue?vue&type=style&index=0&id=e999c3a8&prod&lang=css&"
import style1 from "./C_ShowPage.vue?vue&type=style&index=1&id=e999c3a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e999c3a8",
  null
  
)

export default component.exports